// GLOBAL actions
/* eslint-disable */
import axios from 'axios';
import types from './types';

export default {
  [types.STORE_LANGUAGE]: ({ commit }, payload) => {
    commit('STORE_LANGUAGE', payload);
  },
  [types.STORE_IN_QUEUE]: ({ commit }, payload) => {
    commit('STORE_IN_QUEUE', payload);
  },
  [types.UPDATE_IN_QUEUE]: ({ commit }, payload) => {
    commit('UPDATE_IN_QUEUE', payload);
  },
  [types.TRACK_IMPORT_PROGRESS]: async (context, payload) => {
    try {
      return await axios.get(`progress-track/${payload}`).then((res) => res);
    } catch (err) {
      console.error(err);
    }
  },
  [types.REMOVE_FROM_QUEUE]: ({ commit }, payload) => {
    commit('REMOVE_FROM_QUEUE', payload);
  },
  [types.STORE_ID_QUEUE]: ({ commit }, payload) => {
    commit('STORE_ID_QUEUE', payload);
  },
  // GLOBAL SEARCH
  [types.GET_GLOBAL_SEARCH]: async ({ commit }, payload) => {
    try {
      return await axios.get(`global-search?query=${payload}`).then((res) => {
        return res.data.data;
      });
    } catch (err) {
      console.error(err);
    }
  },
};

